import {Component, Inject} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {DesktopHost, EditingWorkspace} from '../../types-repository';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-mount-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">Mount {{ data.workspace.mountPoint }} ({{ data.workspace.volumeSizeGiB }} GiB)</div>
        <div class="modal-body">
          <table class="cl-table-data">
            <thead>
            <tr>
              <th class="cl-table-head">Host</th>
              <th class="cl-table-head">Type</th>
              <th class="cl-table-head">Pool</th>
              <th class="cl-table-head cl-th-links"></th>
            </tr>
            </thead>
            <tbody>
            @for (host of data.hosts; track host.instanceId) {
              <tr>
                <td>
                  <strong>{{ host.name || host.instanceId }}</strong>
                  <br><small class="cl-faded">{{ host.instanceId }}</small>
                </td>
                <td>{{ host.instanceType }}</td>
                <td>
                  <span class="cl-font-monospace">{{ host.pool }}</span>
                  @if (host.pool !== data.workspace.pool && data.poolFor(host)) {
                    <br><small class="cl-color-honey">Other pool: {{ data.workspace.pool }} content on this host is
                      visible to everyone who uses it</small>
                  }
                </td>
                <td class="cl-td-links" width="1%">
                  @if (mountingHost === host.instanceId) {
                    <span class="cl-color-honey"><i class="fas fa-spinner fa-spin"></i> Mounting...</span>
                  } @else if (!data.poolFor(host)) {
                    <span class="cl-faded" title="Your role may not mount {{ data.workspace.pool }} workspaces on {{ host.pool }} hosts">
                      <i class="fas fa-lock" aria-hidden="true"></i> Not allowed</span>
                  } @else if (!mountingHost) {
                    <a class="cl-a-btn cl-a-primary" (click)="mount(host)">Mount here</a>
                  }
                </td>
              </tr>
            }
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <span class="modal-footer-left"></span>
          <span class="modal-footer-center">
            <button type="button" class="btn cl-color-primary" (click)="dialogRef.close()">
              <span>Close</span>
            </button>
          </span>
          <span class="modal-footer-right"></span>
        </div>
      </div>
    </div>
  `,
})
export class MountDialogComponent {
  mountingHost: string | null = null;

  constructor(
    public dialogRef: DialogRef<MountDialogComponent>,
    @Inject(DIALOG_DATA) public data: {
      workspace: EditingWorkspace;
      hosts: DesktopHost[];
      poolFor: (host: DesktopHost) => string | null;
      onMount: (host: DesktopHost, pool: string, done: (success: boolean) => void) => void;
    },
  ) {}

  mount(host: DesktopHost) {
    const pool = this.data.poolFor(host);
    if (!pool) {
      return;
    }
    this.mountingHost = host.instanceId;
    this.data.onMount(host, pool, (success) => {
      if (success) {
        this.dialogRef.close();
      } else {
        this.mountingHost = null;
      }
    });
  }
}
